import React, { useState, useEffect } from 'react';
import { Button } from './Button';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
    const [click, setClick] = useState(false);
    const [button, setButton] = useState(true);

    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);

    const showButton = () => {
        if (window.innerWidth <= 960) {
            setButton(false);
        } else {
            setButton(true);
        }
    };

    useEffect(() => {
        showButton()
    }, []);

    window.addEventListener('resize', showButton);

    return (
        <>
            <nav className='navbar'>
                <div className='navbar-container'>
                    <Link to='/' className='navbar-logo' onClick={closeMobileMenu}>
                        <img class="resize" src={"./logo_texto.png"} />
                    </Link>
                    <div className='menu-icon' onClick={handleClick}>
                        <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
                    </div>
                    <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                        <li className='nav-item'>
                            <Link to='/porque-se-cadastrar' className='nav-links' onClick={closeMobileMenu}>
                                Porque se cadastrar?
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link
                                to='/requisitos'
                                className='nav-links'
                                onClick={closeMobileMenu}
                            >
                                Requisitos
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link
                                to='/numeros'
                                className='nav-links'
                                onClick={closeMobileMenu}
                            >
                                N&uacute;meros
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link
                                to='/bibliograficos'
                                className='nav-links'
                                onClick={closeMobileMenu}
                            >
                                Materiais Bibliogr&aacute;ficos
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link
                                to='/objetivo'
                                className='nav-links'
                                onClick={closeMobileMenu}
                            >
                                Objetivo
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link
                                to='/parceiros'
                                className='nav-links'
                                onClick={closeMobileMenu}
                            >
                                Parceiros
                            </Link>
                        </li>

                        <li>
                            <Link
                                to='/cadastro'
                                className='nav-links-mobile'
                                onClick={closeMobileMenu}
                            >
                                Cadastre-se
                            </Link>
                        </li>
                    </ul>
                    <Link to='/cadastro'>
                        {button && <Button buttonStyle='btn--outline'>CADASTRE-SE</Button>}
                    </Link>
                </div>
            </nav>
        </>
    );
}

export default Navbar;